<div class="developers-container" snAssistantSurface="webhookList" surfaceTitle="Webhooks">
  <div class="developers-header">
    <div class="title-section">
      <h1 i18n="@@developers.title">Developers</h1>
      <p class="subtitle" i18n="@@developers.subtitle">Manage webhooks and integrations</p>
    </div>
  </div>

  <p-tabs [value]="activeTab()" (valueChange)="onTabChange($any($event))">
    <p-tablist>
      <p-tab value="webhooks" i18n="@@developers.tab.webhooks">Webhooks</p-tab>
      <p-tab value="oauth" i18n="@@oauthApps.tabName">OAuth Applications</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="webhooks">
        <div class="tab-header">
          <p-iconfield class="filter-field">
            <p-inputicon styleClass="pi pi-search" />
            <input
              pInputText
              type="text"
              i18n-placeholder="@@developers.filter.url"
              placeholder="Filter by URL"
              [(ngModel)]="urlFilter"
              (ngModelChange)="applyFilter()"
              snAssistantSkip />
          </p-iconfield>
          <p-button
            class="desktop-add-btn"
            i18n-label="@@developers.addWebhook"
            label="Add Webhook"
            icon="pi pi-plus"
            (click)="addWebhook()">
          </p-button>
        </div>

        <div class="table-section">
          <p-table
            [value]="filteredWebhooks()"
            [loading]="loading()"
            styleClass="webhooks-table">

            <ng-template pTemplate="header">
              <tr>
                <th>URL</th>
                <th class="enabled-col" i18n="@@developers.col.enabled">Enabled</th>
                <th class="events-col" i18n="@@developers.col.events">Events</th>
                <th class="actions-col" i18n="@@campaignItems.col.actions">Actions</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-webhook>
              <tr class="clickable-row" (click)="editWebhook(webhook)">
                <td>
                  <div class="webhook-url">{{ webhook.url || '-' }}</div>
                </td>
                <td class="enabled-col">
                  <i [class]="webhook.enabled ? 'pi pi-check-circle enabled-icon' : 'pi pi-times-circle disabled-icon'"></i>
                </td>
                <td class="events-col">
                  <div class="event-types">
                    @for (event of webhook.event_types; track event) {
                      <span class="event-tag">{{ event }}</span>
                    }
                    @if (!webhook.event_types?.length) {
                      <span class="no-events">-</span>
                    }
                  </div>
                </td>
                <td class="actions-col">
                  <div class="actions-buttons">
                    <p-button
                      icon="pi pi-history"
                      [text]="true"
                      severity="secondary"
                      size="small"
                      i18n-pTooltip="@@developers.requestHistory"
                      pTooltip="Request History"
                      tooltipPosition="top"
                      [routerLink]="['/developers/webhooks', webhook.id, 'requests']"
                      (click)="$event.stopPropagation()"
                      i18n-ariaLabel="@@developers.requestHistory"
                      ariaLabel="Request History">
                    </p-button>
                    <p-button
                      icon="pi pi-pencil"
                      [text]="true"
                      severity="secondary"
                      size="small"
                      i18n-pTooltip="@@common.edit"
                      pTooltip="Edit"
                      tooltipPosition="top"
                      (click)="editWebhook(webhook); $event.stopPropagation()"
                      i18n-ariaLabel="@@common.edit"
                      ariaLabel="Edit">
                    </p-button>
                    <p-button
                      icon="pi pi-trash"
                      [text]="true"
                      severity="danger"
                      size="small"
                      i18n-pTooltip="@@common.delete"
                      pTooltip="Delete"
                      tooltipPosition="top"
                      (click)="confirmDelete(webhook, $event)"
                      [snAssistantAction]="'delete.' + webhook.id"
                      [actionLabel]="'Delete webhook ' + webhook.url"
                      actionDangerous
                      actionHint="Deletes the webhook. Events stop being reported to that address, silently."
                      i18n-ariaLabel="@@common.delete"
                      ariaLabel="Delete">
                    </p-button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4" class="empty-message" i18n="@@developers.empty">
                  No webhooks configured yet
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabpanel>
      <p-tabpanel value="oauth">
        <app-oauth-applications></app-oauth-applications>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <!-- Mobile Bottom Bar -->
  <div class="mobile-bottom-bar">
    <p-button
      i18n-label="@@developers.addWebhook"
      label="Add Webhook"
      icon="pi pi-plus"
      (click)="addWebhook()">
    </p-button>
  </div>
</div>

<app-delete-confirmation
  [(visible)]="deleteDialogVisible"
  [title]="deleteTitle"
  [subtitle]="deleteSubtitle"
  [deleting]="deleting"
  (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()">
</app-delete-confirmation>
